// src/@chakra-ui/gatsby-plugin/theme.js
import theme from "../../theme";

export default theme;
